import React, { FC, useContext, useState, useEffect } from 'react';
import { Context } from '../..';
import { Link, useNavigate } from "react-router-dom";
import { ModalPopoverRightTop } from '../pages/modal/modal-popover-rt';
import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import {isEmpty} from 'underscore';
import UserService from "../../services/UserService";
import {SearchModal} from "../pages/modal/SearchModal";

const BVI: FC = () => {

    const setVar = (myvar: string) => {
        const name = myvar.substring(0, myvar.length - 1);
        document.body.classList.forEach(className => {
            if (className.indexOf(name) === 0) {
                document.body.classList.remove(className);
            }
        })
        document.body.classList.add(myvar);
    };

    const clearClasses = () => {
        let i = 4;
        while (i > 0) {
            document.body.classList.forEach(className => {
                document.body.classList.remove(className);
            });
            i--;
        }
    }

    return (
        <div>
            <table className="table">
                <tbody style={{ cursor: "pointer" }}>
                    <tr>
                        <td><Trans>Fatness</Trans></td>
                        <td onClick={() => setVar('tw1')}><i className='icon tw1' /></td>
                        <td onClick={() => setVar('tw0')}><i className='icon tw0' /></td>
                        <td onClick={() => setVar('tw2')}><i className='icon tw2' /></td>
                    </tr>
                    <tr>
                        <td><Trans>Font</Trans></td>
                        <td onClick={() => setVar('ts1')}><i className='icon ts1' /></td>
                        <td onClick={() => setVar('ts0')}><i className='icon ts0' /></td>
                        <td onClick={() => setVar('ts2')}><i className='icon ts2' /></td>
                    </tr>
                    <tr>
                        <td><Trans>Interval</Trans></td>
                        <td onClick={() => setVar('ls1')}><i className='icon ls1' /></td>
                        <td onClick={() => setVar('ls0')}><i className='icon ls0' /></td>
                        <td onClick={() => setVar('ls2')}><i className='icon ls2' /></td>
                    </tr>
                    <tr>
                        <td><Trans>Color</Trans></td>
                        <td onClick={() => setVar('ec1')}><i className='icon ec1' /></td>
                        <td onClick={() => setVar('ec0')}><i className='icon ec0' /></td>
                        <td onClick={() => setVar('ec2')}><i className='icon ec2' /></td>
                    </tr>
                </tbody>
            </table>
            <input type="button" className='btn btn-warning' value="Сбросить" onClick={() => clearClasses()} />
        </div>

    );
};

const Lang: FC = () => {

    const { store } = useContext(Context);

    return (
        <div>
            <table className="table">
                <tbody style={{ cursor: "pointer" }}>
                    <tr onClick={() => store.setLang("ba")}>
                        <td>Башҡортса</td>
                    </tr>
                    <tr onClick={() => store.setLang("ru")}>
                        <td>Русский</td>
                    </tr>
                    <tr onClick={() => store.setLang("en")}>
                        <td>English</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export const Header: FC = observer(() => {

    // const location = useLocation();
    const { store } = useContext(Context);
    const [bviToggle, setBviToggle] = useState<boolean>(false);
    const [langToggle, setLangToggle] = useState<boolean>(false);
    const [searchModal, setSearchModal] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (store.user.is_active) {
            if (store.user.is_staff) {
                if (!store.specInfo?.fio?.length
                    || !store.specInfo?.municipality?.length
                    || !store.specInfo?.phone?.length
                    || !store.specInfo?.snils?.length
                    || isEmpty(store.specInfo?.organizations)
                    || isEmpty(store.specInfo?.specializations)) {
                    navigate('/config');
                }
            } else if (!store.userInfo?.fio?.length
                || !store.userInfo?.snils?.length
                || !store.userInfo?.phone?.length) {
                navigate('/config');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    const loginToIS = () => {
        store.loginToMonitoring()
            .then(res => {
                if (res['url']) {
                    window.location.href = res['url'];
                } else {
                    alert('Ошибка входа!');
                }
            })
    }


    return (
        <div className="row">
            <div className="col-md-2">
                <Link className="nav-link text-light" to="/">
                    <img src='/images/morb.png' alt='logo' className='logo' />
                </Link>
            </div>
            <div className="col-md-5">
                <h3><Trans>Navigator of Inclusive Education of the Republic of Bashkortostan</Trans></h3>
                <h4><Trans>Information portal</Trans></h4>
            </div>
            <div className="col-md-3">
                <div className="d-flex">
                    <div className='bvi-block mb-4'>
                        <span onClick={() => setBviToggle(true)}><i className='icon bvi' /><Trans>visually impaired</Trans></span>
                    </div>
                </div>

                <a href="mailto:inc_portal@mail.ru" target="_blank" rel="noreferrer" className='mb-5'>
                    <h6>
                        <i className="icon mail" />
                        inc_portal@mail.ru
                    </h6>
                </a>

                <div className="mt-4 h6">
                    <Link className="nav-link text-light m-0 p-0" to="/feedback"><i className='icon write' /><Trans>Feedback</Trans></Link>
                </div>

                {store.user.is_superuser ?
                    <div className="mt-4 h6">
                        <Link className="nav-link text-light m-0 p-0" to=""><span onClick={() => loginToIS()} ><i className='icon login' /><Trans>Log in to the IS Monitoring</Trans></span></Link>
                    </div>
                    : null}


            </div>
            <div className="col-md-2">
                <div className='mt-1 mr-0 h-100'>
                    {store.isAuth ?
                        <>
                            <Link className="nav-link text-light m-0 align-self-start" to="/config"><i className='icon user' />{store.user.name}</Link>
                            <Link className="nav-link text-light m-0 align-self-start" to="/" onClick={() => store.logout()}><i className='icon logout' /><Trans>Exit</Trans></Link>
                        </>
                        :
                        <Link className="nav-link text-light m-0 align-self-start" to="/login" onClick={() => store.logout()}><i className='icon login' /><Trans>Login</Trans>/<Trans>Registration</Trans></Link>
                    }
                    <Link className="nav-link text-light m-0 align-self-start" to="" onClick={() => setLangToggle(true)}><i className='icon language' /><Trans>English</Trans></Link>
                    <div className="d-flex">
                        <input
                            className="align-self-center p-2 shadow-none rounded rounded-2"
                            type="search"
                            readOnly={true}
                            placeholder={store.lang === 'ba' ? 'Эҙләү' : store.lang === 'ru' ? 'Поиск' : 'Search'}
                            onClick={() => setSearchModal(true)}
                        />
                    </div>

                </div>
            </div>
            <ModalPopoverRightTop
                toggle={bviToggle}
                setToggle={setBviToggle}
                title={store.lang === 'ba' ? 'Насар күреүселәр өсөн сайтты төҙләү' : store.lang === 'ru' ? 'Настройка сайта для слабовидящих' : 'Setting up a website for the visually impaired'}
                modalContent={<BVI />}
                clickedButtonOne={() => { }}
                clickedButtonTwo={() => setBviToggle(false)}
                ButtonOneValue=''
                ButtonTwoValue=''
            />
            <ModalPopoverRightTop
                toggle={langToggle}
                setToggle={setLangToggle}
                title={store.lang === 'ba' ? 'Телде һайлағыҙ' : store.lang === 'ru' ? 'Выберите язык' : 'Сhoose the language'}
                modalContent={<Lang />}
                clickedButtonOne={() => { }}
                clickedButtonTwo={() => setLangToggle(false)}
                ButtonOneValue=''
                ButtonTwoValue=''
            />
            <SearchModal toggle={searchModal} setToggle={setSearchModal} />
        </div>
    );
});